<template>
  <v-app>
    <v-app-bar fixed dark color="grey darken-4" :height="expanding ? 200 : 56"
      :style="{ transition: 'height 0.3s ease' }">
      <v-toolbar-title>TecZoa</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon small class="mx-0" v-bind="attrs" v-on="on" @click="irAlBlog">
            <v-icon small>mdi-post-outline</v-icon>
          </v-btn>
        </template>
        <span>Foro</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon small class="mx-0 ml-1" v-bind="attrs" v-on="on" @click="irAEventos">
            <v-icon small>mdi-calendar-star</v-icon>
          </v-btn>
        </template>
        <span>Eventos</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon small class="mx-0 ml-1" v-bind="attrs" v-on="on" @click="irALinksTec">
            <v-icon small>mdi-link-variant</v-icon>
          </v-btn>
        </template>
        <span>Gestor de enlaces</span>
      </v-tooltip>
      <div class="d-inline-flex align-center ml-1" style="border: 1px solid rgba(255,255,255,0.4); border-radius: 16px; padding: 2px 4px;">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon small class="mx-0" v-bind="attrs" v-on="on" @click="irATienda">
              <v-icon small>mdi-store</v-icon>
            </v-btn>
          </template>
          <span>Tienda</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon small class="mx-0" v-bind="attrs" v-on="on" @click="irAlCarrito">
              <v-badge :content="cantidadCarrito" :value="cantidadCarrito > 0" color="red" overlap>
                <v-icon small>mdi-cart</v-icon>
              </v-badge>
            </v-btn>
          </template>
          <span>Carrito</span>
        </v-tooltip>
      </div>
      <AvatarUsuario class="ml-1" />
    </v-app-bar>

    <v-main style="margin-top: 56px;">
      <router-view />
    </v-main>

    <FooterPerfilStore />
    <BotonFlotanteTienda />
    <SessionTimer />
  </v-app>
</template>

<script>
import FooterPerfilStore from '@/components/common/FooterPerfilStore';
import BotonFlotanteTienda from '@/components/common/navegacion/BotonFlotanteTienda.vue';
import AvatarUsuario from '@/components/common/navegacion/AvatarUsuario.vue';
import SessionTimer from '@/components/common/SessionTimer.vue';

export default {
  name: 'RutasStore',
  components: { FooterPerfilStore, BotonFlotanteTienda, AvatarUsuario, SessionTimer },
  data() {
    return {
      expanding: false
    };
  },
  computed: {
    cantidadCarrito() {
      return this.$store.getters.cantidadCarrito;
    }
  },
  methods: {
    irATienda() {
      if (this.$route.path !== '/store/all') {
        this.expanding = true;
        setTimeout(() => {
          this.$router.push('/store/all');
        }, 300);
      }
    },
    irAlBlog() {
      if (this.$route.path !== '/blog') {
        this.$router.push('/blog').catch(() => {});
      }
    },
    irAEventos() {
      if (this.$route.path !== '/eventos') {
        this.$router.push('/eventos').catch(() => {});
      }
    },
    irALinksTec() {
      if (this.$route.path !== '/linkstec') {
        this.$router.push('/linkstec').catch(() => {});
      }
    },
    irAlCarrito() {
      if (this.$route.path !== '/store-carrito') {
        this.$router.push('/store-carrito');
      }
    }
  }
};
</script>
